import React from 'react'
import { Stack, Button } from '@mui/material';
import error from '../../Assets/images/svg/Oops404.svg'
import { FcRefresh } from "react-icons/fc";
import { GrHomeRounded } from "react-icons/gr";
import { useNavigate } from 'react-router-dom';
import Dashboard from '../../Layout/Dashboard/Dashboard';

const Pagenotfound = () => {
    const navigate = useNavigate();
    const handleButtonClick = () => {
        navigate('/main/Dashboard');
    };
    return (
        // 404 error start here 
        <Stack
            direction="column"
            justifyContent="center"
            alignItems="center"
            spacing={4}>

            <Stack>
                <img
                    src={error}
                    alt="pic"
                    style={{ width: "26rem", userSelect: "none" }}
                />
            </Stack>
            <Stack>
                <Stack spacing={1} direction="row">
                    <Button
                        disableElevation
                        variant="contained" sx={{
                            textTransform: "math-auto",
                        }}
                        onClick={handleButtonClick}>
                        <GrHomeRounded className='me-2' />Return to home</Button>

                    <Button variant="outlined" sx={{
                        textTransform: "math-auto",
                    }}>

                        <FcRefresh className='me-2' />Refresh </Button>
                </Stack>
            </Stack>

        </Stack>
        // 404 error end here 
    )
}

export default Pagenotfound
